import { IdGeneratorService } from './../../../../services/id-generator.service';
import { AppFrameContextService } from '@sdbn/common';
import { AccountInfoService } from '@sdbn/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { DialogService } from '@sdbn/common';
import { ArticleType, ArticleTypeAttribute, ArticleTypeAttributeGroup, ArticleTypeCalculationRuleAttribute } from '../../article-type.model';
import { ArticleTypeService } from '../../article-type.service';
import { ArticleTypeAttributeEditorComponent } from '../article-type-attribute-editor/article-type-attribute-editor.component';
import { ArticleTypeAttributeGroupEditorComponent } from '../article-type-attribute-group-editor/article-type-attribute-group-editor.component';
import { ArticleTypeBaseArticleDefinitionEditorComponent } from '../article-type-base-article-definition-editor/article-type-base-article-definition-editor.component';
import { ArticleTypeCalculationRuleEditorComponent } from '../article-type-calculation-rule-editor/article-type-calculation-rule-editor.component';

@Component({
  selector: 'app-article-type-admin',
  templateUrl: './article-type-admin.component.html',
  styleUrls: ['./article-type-admin.component.scss']
})
export class ArticleTypeAdminComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  data = new Array<ArticleType>();

  selected: ArticleType;
  selectedId: number;

  subscription: Subscription;

  new = false;

  manageArticleTypePermitted = false;

  constructor(
    private accountInfoService: AccountInfoService,
    private appFrameContextService: AppFrameContextService,
    public translationService: TranslationService,
    private articleTypeService: ArticleTypeService,
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI,
    private idGenerator: IdGeneratorService
  ) {

    super();

    this.subscription = articleTypeService.changed$.subscribe(() => {
      this.updateDataFromService();
    });

    this.updateDataFromService();
  }

  updateDataFromService() {
    if (this.checkUserHasPrivilegeManageArticleType()) {
      this.data = this.articleTypeService.articleTypes;
      let newSelected: ArticleType = null;
      for (let type of this.data) {
        if (type.id === this.selectedId) {
          newSelected = type;
        }
      }
      this.selected = newSelected != null ? newSelected : this.data[0];
    }

  }

  ngOnInit(): void {
    this.translationService.changed.subscribe(newLanguage => {
      this.calculateListEntryTitles();
    });
    if (!this.checkUserHasPrivilegeManageArticleType()) {
      this.dialogService.showInfoDialog('shared.tmc-http-interceptor.error.403.title',
      'shared.tmc-http-interceptor.error.403.message');
    } else {
      this.manageArticleTypePermitted = true;
    }
  }

  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    if (entry !== this.selected) {
      this.selected = entry as ArticleType;
      this.selectedId = this.selected.id;
    }
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    this.selected = new ArticleType({ id: this.idGenerator.getNextId() });
    console.log(this.selected);
  }

  onCancel() {
    this.articleTypeService.refreshData();
    this.selected = this.data.length > 0 ? this.data[0] : null;
  }

  onSave() {
    this.appServerAPI.execute<number>('/client/erp-article/article-type/saveArticleType', this.selected).subscribe(response => {

      this.articleTypeService.refreshData();

    }, error => {
      console.log('error is', error);
    });

  }

  saveDisabled(): boolean {
    return this.selected == null
            || this.selected.name == null
            || this.selected.name.values == null
            || this.selected.name.values.length === 0
            || !this.selected.name.checkValueExistsForLanguage('de');
  }

  addAttributeGroup() {
    this.dialogService.openDefault(ArticleTypeAttributeGroupEditorComponent, { articleType: this.selected })
      .afterClosed().subscribe(() => {
        this.reorderData();
      });
  }

  editAttributeGroup = (group: ArticleTypeAttributeGroup): void => {
    this.dialogService.openDefault(ArticleTypeAttributeGroupEditorComponent, { articleType: this.selected, attributeGroup: group }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.reorderData();
      }
    });
  }

  removeAttributeGroup = (group: ArticleTypeAttributeGroup): void => {
    this.dialogService.showConfirm('erp.ui.articletype.dialog.remove-attributegroup.title', 'erp.ui.articletype.dialog.remove-attributegroup.message')
        .afterClosed().subscribe(confirmed => {
      if (confirmed) {
        group.deleted = true;
      }
    });
  }

  addAttribute() {
    this.dialogService.openMiddle(ArticleTypeAttributeEditorComponent, { articleType: this.selected }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.reorderData();
      }
    });
  }

  editAttribute = (attribute: ArticleTypeAttribute, group: ArticleTypeAttributeGroup): void => {
    this.dialogService.openMiddle(ArticleTypeAttributeEditorComponent, { articleType: this.selected, attribute: attribute, group: group }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.reorderData();
      }
    });
  }

  removeAttribute = (attribute: ArticleTypeAttribute, group: ArticleTypeAttributeGroup): void => {
  this.dialogService.showConfirm('erp.ui.articletype.dialog.remove-attribute.title', 'erp.ui.articletype.dialog.remove-attribute.message')
        .afterClosed().subscribe(confirmed => {
      if (confirmed) {
        attribute.deleted = true;
      }
    });
  }

  addCalculationRule() {
    this.dialogService.openMiddleWidthMaxHeigh(ArticleTypeCalculationRuleEditorComponent, { articleType: this.selected }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.reorderData();
      }
    });
  }

  editCalculationRule = (calculationRuleAttribute: ArticleTypeCalculationRuleAttribute): void => {
    this.dialogService.openMiddleWidthMaxHeigh(ArticleTypeCalculationRuleEditorComponent, { articleType: this.selected, calculationRuleAttribute: calculationRuleAttribute }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.reorderData();
      }
    });
  }

  removeCalculationRule = (calculationRuleAttribute: ArticleTypeCalculationRuleAttribute): void => {
    this.dialogService.showConfirm('erp.ui.articletype.dialog.remove-calculationrule.title', 'erp.ui.articletype.dialog.remove-calculationrule.message')
        .afterClosed().subscribe(confirmed => {
      if (confirmed) {
        calculationRuleAttribute.deleted = true;
        this.reorderData();
      }
    });
  }

  editBaseArticleDefinition() {
    console.log('editBaseArticleDefinition', this.selected);
    const dialogRef = this.dialogService.openMiddle(ArticleTypeBaseArticleDefinitionEditorComponent, { articleType: this.selected }).afterClosed().subscribe(result => {
      console.log('editBaseArticleDefinition.after', this.selected);
      this.reorderData();
    });
  }

  private calculateListEntryTitles() {
    const language = this.translationService.language;
    for (const articleType of this.articleTypeService.articleTypes) {
      articleType.calculateTitle(language);
    }
  }

  private reorderData() {
    if (this.selected != null) {
      this.selected.attributeGroups.sort((a, b) => {
        if (a.sortValue == null && b.sortValue == null) {
          return 0;
        }
        if (a.sortValue == null || b.sortValue == null) {
          return 1;
        }
        return a.sortValue.localeCompare(b.sortValue);
      });
      for (const group of this.selected.attributeGroups) {
        group.attributes.sort((a, b) => a.sortValue.localeCompare(b.sortValue));
      }
      this.selected.calculationRules.sort((a, b) => a.sortValue.localeCompare(b.sortValue));
    }
  }

  private checkUserHasPrivilegeManageArticleType(): boolean {
    const yardKey = this.appFrameContextService.tenant.value?.key;
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'erp.manage-articletype');
  }
}
